import { render, staticRenderFns } from "./CategoriesList.vue?vue&type=template&id=cd3c8074&scoped=true"
import script from "./CategoriesList.vue?vue&type=script&lang=js"
export * from "./CategoriesList.vue?vue&type=script&lang=js"
import style0 from "./CategoriesList.vue?vue&type=style&index=0&id=cd3c8074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3c8074",
  null
  
)

export default component.exports